import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";
import { Income } from "./useIncome";

/**
 * Hook especializado para cargar ingresos de un booking específico
 * NO depende de propiedades, carga directamente por booking_id
 */
export const useIncomeByBookingId = (bookingId: string) => {
  return useQuery({
    queryKey: ["income-by-booking", bookingId],
    enabled: !!bookingId,
    queryFn: async (): Promise<Income[]> => {
      const { data, error } = await supabase
        .from("property_income")
        .select(`
          *,
          bookings!inner(
            booking_id,
            guest_name,
            property_short_name,
            property_id
          )
        `)
        .eq("booking_id", bookingId)
        .order("payout_date", { ascending: false });

      if (error) throw error;

      // Transform data
      return (data || []).map((item: any) => ({
        ...item,
        guest_name: item.bookings?.guest_name || "",
        property_id: item.bookings?.property_id || "",
        property_short_name: item.bookings?.property_short_name || "",
      })) as Income[];
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000,
  });
};
